import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as analytics from '@eb/site-analytics';

import withMainControls from 'eventbrite_design_system/structure/hoc/withMainControls';
import withOverlayControls from 'eventbrite_design_system/structure/hoc/withOverlayControls';
import { saveEvent as saveEventAction } from '../actions/event';
import { getLocationSuggestions } from '@eb/destination-utils';

import {
    searchLocationSuggestions as searchLocationSuggestionsAction,
    locationChange as locationChangeAction,
    getUserCurrentLocation as getUserCurrentLocationAction,
} from '../actions/location';
import { trackPageView as trackPageViewAction } from '../actions/analytics';
import { getMaskState } from '../utils';

import CityBrowseBaseScreen from '../components/CityBrowseBaseScreen';

import { GA_CITY_BROWSE_CATEGORY } from '../constants';

const { trackEventFromState } = analytics;

export const _mapStateToProps = (state) => ({
    bucketConfigs: state.content.entityContext,
    currentPlace: state.location.currentPlace,
    h1Prefix: state.location.h1Prefix,
    cityBlurb: state.location.cityBlurb,
    locationSuggestions: getLocationSuggestions(
        state.location,
        state.app.featureFlags.useCurrentLocation,
    ),
    shouldHideMask: getMaskState(state.brand, state.location.isOnline),
    domain: state.app.domain,
    featureFlags: state.app.featureFlags,
    experiments: state.app.experiments,
    locationDenied: state.location.locationDenied,
    isWaitingForLocation: state.location.isWaitingForLocation,
    isOnline: state.location.isOnline,
    isAuthenticated: state.auth.isAuthenticated,
    trackGAEvent: (action) =>
        trackEventFromState(state, {
            category: GA_CITY_BROWSE_CATEGORY,
            ...action,
        }),
    ...state.brand,
});

const _mapDispatchToProps = (dispatch, ownProps) => ({
    onSaveEvent: (...args) => dispatch(saveEventAction(...args)),
    handleLocationSuggestionChange: (...args) =>
        dispatch(searchLocationSuggestionsAction(...args)),
    handleLocationSelect: (locationChangeObj = {}) =>
        dispatch(
            locationChangeAction({
                ...locationChangeObj,
                history: ownProps.history,
            }),
        ),
    onTrackPageViewAction: (...args) => dispatch(trackPageViewAction(...args)),
    handleUseCurrentLocation: (...args) =>
        dispatch(getUserCurrentLocationAction(...args)),
});

export default withOverlayControls(
    withMainControls(
        withRouter(
            connect(
                _mapStateToProps,
                _mapDispatchToProps,
            )(CityBrowseBaseScreen),
        ),
    ),
);
